/* eslint-disable operator-linebreak */
import * as XLSX from 'xlsx';

export async function load(file: File): Promise<any> {
  const buffer = await file.arrayBuffer();
  // Get workbook
  const workbook = XLSX.read(buffer, { type: 'buffer', cellDates: true });
  const jsonFiles: any = {};
  workbook.SheetNames.forEach(name => {
    const worksheet = workbook.Sheets[name];
    const jsonData = XLSX.utils.sheet_to_json(worksheet);
    jsonFiles[name] = jsonData;
  });
  return jsonFiles;
}
